<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-1 p-pb-1">
      
      <div class="p-grid p-nogutter">
        <div class="p-col">
          <h2>
            {{$t('report.title')}} {{ $route.query.serialNumber ? '- ' +$route.query.serialNumber : '' }}
          </h2>
        </div>
        <div v-if="role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY'" class="p-col-fixed p-pb-4" style="width: fit-content">
          <Button :label="$t('report.button_new_report')" @click="create()" icon="irinox-icon-button pi pi-plus" iconPos="left" />
        </div>
      </div>

        <div class="irinox-form report" >

          <div class="search-bar" style="float: right" v-if="!$route.query.serialNumber">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" :placeholder="$t('report.search')" :aria-label="$t('report.search')" @update:modelValue="freeSearch"/>
            <i class="pi pi-times" @click="() => {filters['global'].value=null; freeSearch();}"/>
          </div>
          <div class="p-formgroup-inline p-ai-center" v-if="!$route.query.serialNumber">
            <div class="p-field">
              <Dropdown id="modelNumber" v-model="filters['modelNumber'].value" :options="modelNumbers" optionLabel="name" optionValue="code"
                :placeholder="$t('report.filter_model_ph')" @change="changeFilters" />
            </div>
            <div class="p-field">
              <Dropdown id="status" v-model="filters['status'].value" :options="statuses" optionLabel="name" optionValue="code"
                :placeholder="$t('report.filter_status_ph')" @change="changeFilters" />
            </div>
          </div>

          <DataTable :value="reports" stripedRows
            v-model:filters="filters" responsiveLayout="stack" dataKey="installationReportId" 
            breakpoint="960px"
            :lazy="true"
            :paginator="true" paginatorPosition="bottom" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
            v-model:first="table.first" :rows="table.rows" :totalRecords="table.totalRecords"
            @update:first="reloadReports"
            :currentPageReportTemplate="'{totalRecords} ' + $t('report.counter')">
            <template #empty>
                {{$t('report.empty_list')}}
            </template>
            <template #loading>
                {{$t('report.loading_list')}}
            </template>

            <Column field="installationReportId" :header="$t('report.col_id')" style="width: 80px"></Column>

            <Column field="updateTimestamp" :header="$t('report.col_date')" >
              <template #body="slotProps">
                <div>
                  <div v-if="is24hour">{{$d(new Date(slotProps.data.updateTimestamp),'long')}}</div>
                  <div v-else>{{$d(new Date(slotProps.data.updateTimestamp),'long12')}}</div>
                </div>
              </template>
            </Column>

            <Column field="serialNumber" :header="$t('report.col_serialnumber')" ></Column>

            <Column field="modelNumber" :header="$t('report.col_model')" >
              <template #body="slotProps">
                <div>
                  {{$functions.fixModelName(slotProps.data.modelNumber)}} 
                </div>
              </template>
            </Column>

            <Column field="companyUser" :header="$t('report.col_company')" ></Column>

            <Column v-if="!role.includes('SERVICE')" field="companyDealer" :header="$t('report.col_dealer')" ></Column>

            <Column field="status" :header="$t('report.col_status')"  style="width: 120px">
              <template #body="slotProps">
                <div v-if="slotProps.data.status == null">{{ $t('report.status_'+slotProps.data.complete) }} <span v-if="!role.includes('SERVICE')">(*)</span></div>
                <div v-else>{{ $t('report.status_'+slotProps.data.status) }}</div>
              </template>
            </Column>

            <Column bodyClass="" class="irinox-table-buttons p-text-right"  style="width: 150px">
              <template #header>
                <span class="sr-only">{{$t('common.actions')}}</span>
              </template>
              <template #body="slotProps">
                <div class="button-body">

                  <img v-if="slotProps.data.complete" src="assets/irinox/icons/download.svg"
                      @click="openDownload($event, slotProps.data)"
                      v-tooltip.left="$t('report.tooltip_download')" :alt="$t('report.tooltip_download')"/>

                  <img v-if="(role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY') && slotProps.data.complete" class="disabled" src="assets/irinox/icons/info_edit.svg" :alt="$t('common.disabled')"/>
                  <i v-else-if="(role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY') && slotProps.data.status=='PENDING_APPROVAL'" class="pi pi-eye" style="font-size: 35px;" @click="edit(slotProps.data.serialNumber, slotProps.data.installationReportId)" v-tooltip.left="$t('report.tooltip_view')" />
                  <img v-else-if="role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY'" src="assets/irinox/icons/info_edit.svg" @click="edit(slotProps.data.serialNumber, slotProps.data.installationReportId)" 
                      v-tooltip.left="$t('report.tooltip_edit')" :alt="$t('report.tooltip_edit')"/>

                  <i v-if="role.includes('INTERNAL') && slotProps.data.complete" class="pi pi-eye disabled"  style="font-size: 35px;"/>
                  <i v-else-if="role.includes('INTERNAL')" class="pi pi-eye" style="font-size: 35px;" @click="edit(slotProps.data.serialNumber, slotProps.data.installationReportId)" v-tooltip.left="$t('report.tooltip_view')" />

                  <i v-if="(role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY')" 
                      class="pi pi-trash" 
                      @click="deleteReport(slotProps.data.installationReportId)"
                      v-tooltip.left="$t('report.tooltip_delete')"
                      :style="{color: slotProps.data.complete || slotProps.data.status=='PENDING_APPROVAL' ? '#a5a5a5' : '#A70008', 'pointer-events': slotProps.data.complete || slotProps.data.status=='PENDING_APPROVAL' ? 'none' : 'auto'}"
                  />
                </div>
              </template>
            </Column>

          </DataTable>

          <ReportDownloadOverlay ref="downloadOverlay" />

        </div>

    </div>
	</div>

  <!--        -->
  <!-- ERRORS -->
  <!--        -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('report.error_dialog')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('report.error_dialog')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />

  <!--              -->
  <!-- DELETE FLOW  -->
  <!--              -->
  <IrinoxDialogDark :visible="dialog.deleteConfirm" 
    mode="confirm" 
    :message="$t('report.delete_dialog')"
    :leftB="$t('report.delete_dialog_cancel')" 
    @click:left-button="cancelDeleteReport" 
    :rightB="$t('report.delete_dialog_ok')" 
    @click:right-button="confirmDeleteReport"
    icon="assets/irinox/icons/delete_big.svg" />

  <IrinoxDialogDark :visible="dialog.deleteSuccess" 
    mode="success" 
    :message="$t('report.delete_success')"
    :life="3000" 
    @update:visible="dialog.deleteSuccess = $event" />

  <IrinoxDialogDark :visible="dialog.deleteError" 
    mode="error" 
    :message="$t('report.delete_error')"
    :life="3000" 
    @update:visible="dialog.deleteError = $event" />

</template>

<script>
import ReportService from '../../service/ReportService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import ReportDownloadOverlay from './ReportDownloadOverlay.vue';
// import IrinoxDialogLight from '../IrinoxDialogLight.vue';
import {FilterMatchMode} from 'primevue/api';
import { mapGetters } from 'vuex';

export default {
    components: {
          IrinoxDialogDark,
          ReportDownloadOverlay,
          // IrinoxDialogLight
    },
    data() {
        return {
          reports: [],
          filters: {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
              'modelNumber': {value: null, matchMode: FilterMatchMode.EQUALS},
              'status': {value: null, matchMode: FilterMatchMode.EQUALS}
          },
          modelNumbers: [{
              code: null,
              name: this.$t('report.filter_remove')
            }],
          statuses: [{ 
              code: null,
              name: this.$t('report.filter_remove') 
            },{ 
              code: "DRAFT",
              name: this.$t('report.status_DRAFT') 
            },{ 
              code: "PENDING_APPROVAL",
              name: this.$t('report.status_PENDING_APPROVAL') 
            },{ 
              code: "REJECTED",
              name: this.$t('report.status_REJECTED') 
            },{ 
              code: "APPROVED",
              name: this.$t('report.status_APPROVED') 
            }],
          table: {
            rows: 50,
            totalRecords: 0,
            first: 0
          },
          freeSearchTimer: null,
          dialog: {
            error: false,
            blockingError: false,
            deleteConfirm: false,
            deleteSuccess: false,
            deleteError: false,
            deleteReportId: null
          },
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          is24hour: 'userdata/is24hour',
          role: 'userdata/role',
          uxData: 'preferences/uxData',
        }),
    },
    watch: {
    },
    created() {
      this.reportService = new ReportService();
    },
    mounted() {
      this.loadModels();
      if (this.$route.query.serialNumber) {
        this.filters['global'].value = this.$route.query.serialNumber;
      } else {
        this.filters = {
          ...this.filters,
          ...(this.$functions.clone(this.uxData['report.list.filters'] ?? {}))
        };
        this.table.first = this.uxData['report.list.paginationFirst'] ?? 0;
      }
      this.reloadReports();
    },
    methods: {
      loadModels() {
        this.reportService.models(this.personaltoken)
          .then((body) => {
            let mns = body.map(m => ({
              code: m.gamma + ' ' + m.name + ' ' + m.accessory,
              name: this.$functions.fixModelName(m.gamma + ' ' + m.name + ' ' + m.accessory)
            }));
            mns.push({ code: 'PRIME', name: this.$functions.fixModelName('PRIME') });
            mns = this.$functions.uniqByKeepFirst(mns, item => item.code)
              .sort((a, b) => this.$functions.compareStrings(a, b, 'name'));
            mns.unshift({ code: null, name: this.$t('report.filter_remove') });
            this.modelNumbers = mns;
          })
          .catch(error => {
            console.error("ERROR loading models " + error);
          });
      },
      freeSearch() {
        clearTimeout(this.freeSearchTimer);
        this.freeSearchTimer = setTimeout(() => {
          this.changeFilters();
        }, 1000);
      },
      changeFilters() {
        if (!this.$route.query.serialNumber) {
          this.$store.commit('preferences/addUxData', { 'report.list.filters': this.$functions.clone(this.filters) });
        }
        this.table.first = 0;
        this.reloadReports();
      },
      reloadReports() {
        this.reportService.getListV2(this.personaltoken, this.filters, this.table)
          .then((data) => {
            if(data.code == 200) {
              if (!this.$route.query.serialNumber) {
                this.$store.commit('preferences/addUxData', { 'report.list.paginationFirst': this.table.first });
              }
              this.table.totalRecords = data.body.count;
              this.reports = data.body.items;
            } else {
              this.reports = [];
              this.table.totalRecords = 0;
              console.error("ERROR " + data.code);
              this.dialog.error = true;
            }
          })
          .catch(error => {
            this.reports = [];
            this.table.totalRecords = 0;
            console.error("ERROR " + error);
            this.dialog.error = true;
          });
      },
      openDownload(event, report) {
        this.$refs.downloadOverlay.open(event, report.serialNumber, report.installationReportId, report.language);
      },
      edit(serialNumber, reportId) {
        this.$router.push({ name: 'report-edit', params: { serialNumber: serialNumber, reportId: reportId } });
      },
      create() {
        this.$router.push({ name: 'report-new', query: { serialNumber: this.$route.query.serialNumber, gamma: this.$route.query.gamma, modelId: this.$route.query.modelId } });
      },
      deleteReport(reportId) {
        this.dialog.deleteReportId = reportId;
        this.dialog.deleteConfirm = true;
      },
      confirmDeleteReport() {
        const reportId = this.dialog.deleteReportId;
        this.dialog.deleteConfirm = false;
        
        this.reportService.delete(this.personaltoken, reportId)
          .then((data) => {
            if (data.code == 200) {
              this.dialog.deleteSuccess = true;
              setTimeout(() => {
                this.dialog.deleteSuccess = false;
                this.reloadReports();
              }, 3000);
            } else {
              console.error("ERROR " + data.code);
              this.dialog.deleteError = true;
            }
          })
          .catch(error => {
            console.error("ERROR " + error);
            this.dialog.deleteError = true;
          });
      },
      cancelDeleteReport() {
        this.dialog.deleteConfirm = false;
        this.dialog.deleteReportId = null;
      }
    }

}
</script>

<style scoped>

.irinox-form .p-dropdown {
  width: 200px;
}

.irinox-form .search-bar input {
  width: 100px;
}

.irinox-form .button-body img.disabled {
  opacity: 0.4;
  filter: alpha(opacity=40);
  -webkit-filter: grayscale(100%);
       -moz-filter: grayscale(100%);
         -o-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
            filter: grayscale(100%);
  cursor: unset;
}

.irinox-form i {
  font-size: 30px;
  cursor: pointer;
}
.irinox-form i.disabled {
  color: grey;
  cursor: unset;
}

.irinox-delete-icon {
  font-size: 30px;
  cursor: pointer;
  transition: color 0.2s;
}

</style>